/* eslint-disable react/prop-types */
import React from 'react';
import { checkmarkOverview, logo } from '../../context/Utils';
import { Context } from '../../context/Context';
import { AppContext, Brands } from '../../context/interfaces';
import { BRAND } from 'shared/utils';
import { ReactComponent as CheckmarkSVG } from '../../assets/icons/checkmark_overview.svg';

import '../../assets/styles/screens/success/Success.scss';

const SuccessScreen = (): JSX.Element => {
	const { eventId } = React.useContext(Context) as AppContext;

	return (
		<div className="success-screen">
			<div className="container">
				<div className="icons">
					{Brands.CSM === BRAND && <img src={logo} alt="logo" className="icons__logo" />}
					{Brands.MULTINATIONAL === BRAND && <img src={logo} alt="logo" className="icons__logo" />}
					{Brands.PREMIER === BRAND && <img src={logo} alt="logo" className="icons__logo" />}
					{Brands.OPTIMA === BRAND && <img src={logo} alt="logo" className="icons__logo" />}
					{Brands.ASSA === BRAND.toLowerCase() ? (
						<CheckmarkSVG className="checkmark" />
					) : (
						<img src={checkmarkOverview} className="checkmark" alt="" />
					)}
				</div>
				<SuccessMessage eventId={eventId} />
			</div>
		</div>
	);
};

const SuccessMessage: React.FC<{ eventId: number | null }> = (props) => {
	switch (BRAND) {
		case Brands.CSM:
			return (
				<>
					<h1>¡Haz terminado tu inspección virtual!</h1>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<p>
						Estaremos revisando los datos, fotos y documentos incluidos en este proceso. Próximamente nos estaremos
						comunicando contigo.
					</p>

					<div className="contact-us">
						<p>
							Si necesitas información adicional, puedes llamar a TeleSeguros Múltiples al <br />
							<a href="tel:7877580101">787.758.0101</a>
						</p>
					</div>
				</>
			);
		case Brands.LAFISE:
			return (
				<>
					<h1>¡Excelente!</h1>
					<p>¡Su inspección ha sido completada!</p>
					<p>Número de expediente es:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>Puedes continuar con tu viaje, te llegará un correo de Seguros LAFISE con los próximos pasos.</p>
						<br />
						<p>Para contactarnos durante horas laborales comuníquese:</p>
						<p>Teléfono: 800-523-4732 / 2246-2700</p>
					</div>
				</>
			);
		case Brands.OCEANICA:
			return (
				<>
					<h1>¡Excelente!</h1>
					<p>¡Su inspección ha sido completada!</p>
					<p>Número de expediente es:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>Puedes continuar con tu viaje y te llegará un correo de MNK seguros con los próximos pasos.</p>
						<br />
						<p>Para contactarnos durante horas laborales comuníquese:</p>
						<p>Teléfono: 800-289-4546 / 4102-7600</p>
					</div>
				</>
			);
		case Brands.ASSA:
			return (
				<>
					<h1>Su solicitud está siendo procesada</h1>
					<p>Número de expediente es:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							Para más información sobre su reclamo, Contáctenos en horario de 8:00 am – 5:00 pm en nuestros diferentes
							canales de atención.
						</p>
						<p>Teléfono: 800-ASSA(2772)</p>
					</div>
				</>
			);
		case Brands.SEGUROS_MUNDIAL:
		case Brands.COMFENALCO:
			return (
				<>
					<h1>¡Haz terminado tu inspección virtual!</h1>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							Estaremos revisando los datos, fotos y documentos incluidos en este proceso. Próximamente nos estaremos
							comunicando contigo.
						</p>
						<p>
							Si necesitas información adicional, puedes llamar al <br />
							<a href="tel:6014321661">601.432.1661</a>
						</p>
					</div>
				</>
			);
		case Brands.QUALITAS:
			return (
				<>
					<h1>Su solicitud está siendo procesada</h1>
					<p>Número de expediente es:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>Para más información sobre su reclamo, contáctenos al número</p>
						<p>800-Quálitas (7825-4827)</p>
					</div>
				</>
			);
		case Brands.MULTINATIONAL:
			return (
				<>
					<h1>¡Haz terminado tu inspección virtual!</h1>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<p>
						Estaremos revisando los datos, fotos y documentos incluidos en este proceso. Próximamente nos estaremos
						comunicando contigo.
					</p>

					<div className="contact-us">
						<p>
							Si necesitas información adicional, puedes llamar al <br />
							<a href="tel:7872003584">787-200-3584</a>
						</p>
					</div>
				</>
			);
		case Brands.PREMIER:
		case Brands.OPTIMA:
			return (
				<>
					<h1>¡Haz terminado tu inspección virtual!</h1>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<p>
						Estaremos revisando los datos, fotos y documentos incluidos en este proceso. Próximamente nos estaremos
						comunicando contigo.
					</p>

					<div className="contact-us">
						<p>
							Si necesitas información adicional, puedes llamar al <br />
							<a href="tel:+17877052535">787.705.2535</a>
						</p>
					</div>
				</>
			);
		default:
			return (
				<>
					<h1>Su solicitud está siendo procesada</h1>
					<p>Número de expediente es:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							Para más información sobre su reclamo, Contáctenos en horario de 8:00 am – 5:00 pm en nuestros diferentes
							canales de atención.
						</p>
						<p>Teléfono: 800-7872 y WhatsApp: 6328-7872</p>
					</div>
				</>
			);
	}
};

export default SuccessScreen;
